export default __webpack_public_path__ + "static/media/sb2.54ad8fa8.png";